<template>
<div>
 <div class="header" id="header">
     <div class="navcontent">
         <div class="logo"><img src="../assets/logo.png" /></div>
         <div id="nav">
             <router-link to="/Index">首页</router-link>
             <router-link to="/Home">节目</router-link>
             <router-link to="/library">分类</router-link>
             <router-link to="/news">新书资讯</router-link>
             <!-- <router-link to="/freevip">免费VIP</router-link> -->
             <!-- <router-link to="/downloadapp">APP下载</router-link> -->
             <router-link to="/about">关于我们</router-link>
             <router-link v-if="$store.state.userInfo.userId" to="/usercenter">会员中心 <img class="headpic" v-if="$store.state.userInfo.faceUrl" :src="$store.state.userInfo.faceUrl | objs"/></router-link> 
             <span v-else class="navtitle" @click="$store.commit('showLogin')">登录</span>
         </div>
         
        <div class="floatRight"><Search /></div>
         
     </div>
 </div>
<div class="h80" id="topheight"></div>
</div>
</template>

<script>
import Search from '@/components/Search.vue'
export default {
    components: {
        Search,
    },
     
}
</script>

<style>
 .header {  
   width: 100%;
     top: 0;
     left: 0;
     right: 0;
     background: #ffffff; 
     border-bottom: 1px solid #F2F4F3;
     z-index: 100;
 }
 .navcontent{width: 1100px; margin: 0 auto;}
 .logo {
     float: left;
     padding-top: 25px;
     padding-right: 30px;
 }

 .logo img {
     width: 120px;
 }

 #nav {
     padding: 30px;
     float: left;
 }

 #nav a,.navtitle {   
     padding: 5px;
     margin: 0 15px;
     text-decoration: none;
     cursor: pointer;
 
font-size: 16px;
font-family: PingFang SC;
font-weight: 500;
color: #869394;

 }

 #nav a.router-link-exact-active {
     color: #42b983;
     border-bottom: 3px solid #42b983;
 }
 .h80{height: 0px; clear:both;}
 .headpic{float: right;border: 1px; border-radius: 15px; width: 30px; height: 30px;}
 .floatRight{float: right;}
</style>
